import {URLS} from "./app-urls";
import {AbstractService, Expands, Filters} from "./abstract-service";
import {RelatedCost} from "../models/basic/related-cost";
import {AxiosResponse} from "axios";
import {trackPromise} from "react-promise-tracker";
import Api from "./api-config";
import {CostAllocation} from "../models/basic/cost-allocation";

export type PendingNreInvoiceFilter = Filters & {
    initial_date?: string,
    final_date?: string,
    ordering?: string,
};

export class PendingNreInvoiceService extends AbstractService<PendingNreInvoiceFilter> {

    constructor() {
        super(URLS.PENDING_NRE_INVOICE);
    }

    override processFilters = (filters?: Filters) : Filters | undefined => {
        const processedFilter = {
            ...filters
        };

        if (processedFilter?.ordering && processedFilter?.ordering.indexOf("part_number.project") > -1) {
          processedFilter.ordering = processedFilter.ordering.replace("part_number.project", "part_number__project__name");
        }

        return processedFilter;
    }

}
